// @flow
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import Slider from 'rc-qempo-slider';
import { FormattedMessage } from 'react-intl';

import filterStyle from '../Filter.scss';
import style from './RangeType.scss';
import icons from '../../../assets/styles/icons.scss';
import './range-type-slider.css';

import type { FilterRangeType } from '../Filter';

type Props = {
  +filterField: FilterRangeType;
};

const Range = Slider.Range;

export default class RangeType extends Component<Props> {

  render() {
    const { filterField } = this.props;
    return (
      <article className={classNames(filterStyle.filterFieldWrap)}>
        <FormattedMessage id={filterField.titleIntl}>{
          txt => <h2 className={classNames(filterStyle.filterTitle, { [filterStyle.open]: filterField.isOpen })}
                     onClick={filterField.handleOpen}>{txt}
            <i className={classNames(filterStyle.caret,
              { [icons.iconMinusLight]: filterField.isOpen },
              { [icons.iconPlusLight]: !filterField.isOpen })}/>
          </h2>
        }</FormattedMessage>
        {filterField.isOpen && (<Fragment>
          <section className={style.filterPrice}>
            <p>{filterField && filterField.minStateValue && `$${filterField.minStateValue.value}`}</p>
            <p>{filterField && filterField.maxStateValue && `$${filterField.maxStateValue.value}`}</p>
          </section>
          <section className={style.rangeWrap}>
            <Range {...filterField.options} className="priceSlider"/>
          </section>
        </Fragment>)
        }
      </article>);
  }
}

RangeType.propTypes = {
  filterField: PropTypes.object.isRequired,
};



// WEBPACK FOOTER //
// ./src/elements/Filter/RangeType/RangeType.jsx